import {
  CookieConsent as PlatformCookieConsent,
  getStoredConsent,
  setStoredConsent,
} from "@platform/core/ui";
import { captureException } from "@/lib/sentry";

export type { ConsentChoice } from "@platform/core/ui";
export { getStoredConsent, setStoredConsent };

interface CookieConsentProps {
  show: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

/**
 * CookieConsent (project wrapper)
 *
 * Thin wrapper around @platform/core/ui CookieConsent that injects
 * Sentry error reporting for localStorage failures.
 * The Privacy Policy link is a standard <a> tag pointing to /privacy.
 *
 * For the generic version (no sentry deps), import directly from
 * "@platform/core/ui".
 */
export default function CookieConsent({ show, onAccept, onDecline }: CookieConsentProps) {
  return (
    <PlatformCookieConsent
      show={show}
      onAccept={onAccept}
      onDecline={onDecline}
      onStorageError={captureException}
      privacyPolicyHref="/privacy"
      privacyPolicyLabel="Privacy Policy"
    />
  );
}
